module.exports = __webpack_public_path__ + "img/package-volume.5a4d601a.svg";